export default {
  kls_user_session(state) {
    return state.user_info.session_key
  },
  user_info(state) {
    return state.user_info
  },
  user_id(state, getters) {
    return getters.user_info.uid
  },
  user_phone(state, getters) {
    return getters.user_info.login_phone
  },
  user_email(state, getters) {
    return getters.user_info.login_email
  },
  user_name(state, getters) {
    return getters.user_info.user_name
  },
  user_role(state, getters) {
    return getters.user_info.role_list
  },
  user_avatar(state, getters) {
    return getters.user_info.user_avatar
  },
  // current_session_list(state) {
  //     return state.current_event.t_session
  // },
  get_lang(state) {
    return state.lang
  },
  get_ajax_count(state) {
    return state.ajax_spin_count
  },
  get_current_session_id(state) {
    return state.current_session_id
  },
  get_current_session_status(state) {
    return state.current_session_status
  },
  get_current_role(state){
    return state.current_role
  },
  get_current_event_id(state){
    return state.current_event_id
  },
  get_assistant_temp_session(state){
    return state.assistant_temp_session
  },
  get_place_map(state){
    return state.place_map
  },
  get_current_identify(state){
    return state.current_identify
  },
  get_identify_list(state){
    return state.user_identify
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js